import { useOrganizationState, useUserState } from '@/state';
import { canConfigureStripe, canRequestRefund, PaymentsAccessInput } from '@/utils/paymentsPermissions';

import { usePermissions } from './usePermissions';

export interface PaymentsPermissions {
  /** Może zlecić zwrot (właściciel, admin HotelSpot, rola `manager`, uprawnienie `all`). */
  canRefund: boolean;
  /** Może zmieniać konfigurację Stripe (właściciel albo admin HotelSpot). */
  canConfigureStripe: boolean;
  /**
   * Wszystkie źródła (claimy, dokument hotelu, profil) już dotarły. Do tego czasu
   * kontrolki są zablokowane, ale nie pokazujemy jeszcze podpowiedzi „tylko właściciel”,
   * żeby nie mignęła właścicielowi przy wejściu na ekran.
   */
  isResolved: boolean;
}

/** Uprawnienia do płatności bieżącego konta w bieżącym hotelu (lustro `paymentsAccess.ts`). */
export const usePaymentsPermissions = (): PaymentsPermissions => {
  const { organizationId, owner, isResolved: organizationResolved } = useOrganizationState();
  const { currentUser, profileIsAdmin } = useUserState();
  const {
    ownerClaim, isAdmin, roles, permissions, claimsLoaded,
  } = usePermissions();

  const input: PaymentsAccessInput = {
    uid: currentUser?.uid,
    organizationId,
    organizationOwner: owner,
    ownerClaim,
    isAdmin: isAdmin || profileIsAdmin === true,
    role: roles,
    permissions,
  };

  return {
    canRefund: canRequestRefund(input),
    canConfigureStripe: canConfigureStripe(input),
    isResolved: claimsLoaded && organizationResolved && profileIsAdmin !== null,
  };
};
